import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';

const routes = [{
    path: 'enotify-terms',
    name: routeName.ENOTIFY_DESCRIPTION,
    component: () => import('@/views/aplCatl640and631/B4/landingPage/Index.vue'),
    meta: { auth: true, metaTitle: '電子通知單服務說明', leaveAlert: true, code: 'B4', unableBack: true },
},
{
    path: 'enotify',
    name: routeName.ENOTIFY,
    component: () => import('@/views/aplCatl640and631/B4/radioForm/Index.vue'),
    meta: { auth: true, metaTitle: '電子通知單服務', leaveAlert: true, code: 'B4', unableBack: true },
    beforeEnter: (to, from, next) => {
        const whiteList = [routeName.ENOTIFY_DESCRIPTION, routeName.CONFIRM_DATA];
        const guideRoute = guideRoutes(from, whiteList, true);
        next(guideRoute);
    },
}];

export default routes;
